<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8527 15.1469L11.4308 10.725C12.4058 9.5875 12.9715 8.11563 12.9715 6.5C12.9715 2.90937 10.0612 0 6.47147 0C2.88178 0 -0.000411987 2.91031 -0.000411987 6.5C-0.000411987 10.0897 2.90959 13 6.47147 13C8.08647 13 9.56053 12.4075 10.6965 11.4328L15.1183 15.8547C15.2433 15.95 15.3715 16 15.4996 16C15.6277 16 15.7555 15.9512 15.853 15.8535C16.0496 15.6594 16.0496 15.3406 15.8527 15.1469ZM6.49959 12C3.44022 12 0.999594 9.53125 0.999594 6.5C0.999594 3.46875 3.44022 1 6.49959 1C9.55897 1 11.9996 3.44062 11.9996 6.5C11.9996 9.55937 9.53084 12 6.49959 12Z"
      fill="#325EA3"
    />
  </svg>
</template>
